<template>
<!-- lecture content -->
    <div  class="text-body-2 my-0">
        <p class=" mx-0 mb-0 mt-1 pa-0 body-2" v-html="lecture.generaltable.conference"></p>
        <p class="mx-0 mb-0 mt-1 pa-0 body-2" v-html="lecture.generaltable.addresse"></p>
         <p v-if="lecture.url_pdf" class="ma-0 pa-0 ">
            <a class=" indigo--text text--darken-2 font-weight-bold" :href="lecture.url_pdf" target="_blanc">
                <img  v-if="!mobile" src="../../../../assets/research/acrobat_icon.png" class="pl-0 pt-1">
                <span v-else class="text-body-2 purple--text text--purple-4 px-0"> Download PDF</span>
            </a>
        </p>
    </div>
</template>
<script>
import {mapGetters} from 'vuex';
export default {
  props:['lecture'],
  computed: {
    ...mapGetters('header',{
        mobile:'mobile',
    })
  },
}
</script>
